<template>
    <SvgIcon
        type="mdi"
        :path="mdiInformation"
        class="ms-2 text-info"
        data-bs-container="body"
        v-popover
        data-bs-custom-class="popover-fare-details"
        data-bs-trigger="focus"
        data-bs-html="true"
        data-bs-title="Fare details"
        :data-bs-content="fareDetails"
        data-bs-placement="right"
        role="button"
        v-if="!isEmpty(booking.fare_details)"
    ></SvgIcon>
</template>

<script setup lang="ts">
import BookingResource from "@/resources/js/types/resources/BookingResource";
import { formatCurrency } from "@classes/Helpers/Currency";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiDetails, mdiHumanWheelchair, mdiInformation } from "@mdi/js";
import { isEmpty } from "lodash";
import { computed } from "vue";
const { booking } = defineProps<{booking:BookingResource}>();
const fareDetails = computed(() => `<ul class="list-group list-group-flush">${booking.fare_details.map((fare) => `<li class="list-group-item">${fare.description}: <span class="fw-bold">${formatCurrency(fare.amount.amount)}</span></li>`).join('')}</ul>`)
</script>

<style scoped>
</style>